export default {
  'common.save': '저장',
  'common.cancel': '취소',
  'common.delete': '삭제',
  'common.edit': '편집',
  'common.confirm': '확인',
  'common.close': '닫기',
  'common.search': '검색',
  'common.loading': '로딩 중...',
  'common.processing': '처리 중...',
  'common.submit': '제출',
  'common.back': '뒤로',
  'common.next': '다음',
  'common.previous': '이전',
  'common.upload': '업로드',
  'common.download': '다운로드',
  'common.downloadAll': '전체 다운로드',
  'common.refresh': '새로고침',
  'common.retry': '다시 시도',
  'common.copy': '복사',
  'common.copied': '복사됨',
  'common.selectAll': '전체 선택',
  'common.clear': '지우기',
  'common.clearAll': '전체 지우기',
  'common.apply': '적용',
  'common.reset': '초기화',
  'common.filter': '필터',
  'common.sort': '정렬',
  'common.export': '내보내기',
  'common.import': '가져오기',
  'common.preview': '미리보기',
  'common.view': '보기',
  'common.add': '추가',
  'common.remove': '제거',
  'common.rename': '이름 변경',
  'common.share': '공유',
  'common.settings': '설정',
  'common.logout': '로그아웃',
  'common.profile': '프로필',
  'common.yes': '예',
  'common.no': '아니요',
  'common.ok': '확인',
  'common.areYouSure': '확실합니까?',
  'common.actionCannotBeUndone': '이 작업은 취소할 수 없습니다.',
  'common.noData': '데이터 없음',
  'common.noResultsFound': '결과를 찾을 수 없습니다',
  'common.somethingWentWrong': '문제가 발생했습니다',
  'common.pleaseTryAgain': '다시 시도해 주세요',
  'common.success': '성공',
  'common.error': '오류',
  'common.warning': '경고',
  'common.info': '정보',
  'common.optional': '선택 사항',
  'common.required': '필수',
  'common.name': '이름',
  'common.title': '제목',
  'common.description': '설명',
  'common.status': '상태',
  'common.actions': '작업',
  'common.date': '날짜',
  'common.time': '시간',
  'common.createdAt': '생성일',
  'common.updatedAt': '수정일',
  'common.type': '유형',
  'common.size': '크기',
  'common.file': '파일',
  'common.folder': '폴더',
  'common.files': '파일',
  'common.folders': '폴더',
  'common.all': '전체',
  'common.none': '없음',
  'common.send': '전송',
  'common.sending': '전송 중...',
  'common.new': '새로 만들기',
  'common.create': '생성',
  'common.duplicate': '복제',
  'common.move': '이동',
  'common.moveTo': '이동 대상',
  'common.selectFile': '파일 선택',
  'common.chooseFile': '파일 선택',
  'common.dragDropFilesHere': '여기에 파일을 끌어다 놓으세요',
  'common.or': '또는',
  'common.browse': '찾아보기',
  'common.continue': '계속',
  'common.skip': '건너뛰기',
  'common.done': '완료',
  'common.finish': '완료',
  'common.start': '시작',
  'common.stop': '중지',
  'common.pause': '일시정지',
  'common.resume': '재개',
  'common.enabled': '사용',
  'common.disabled': '사용 안 함',
  'common.active': '활성',
  'common.inactive': '비활성',
  'common.draft': '초안',
  'common.published': '게시됨',
  'common.archive': '보관',
  'common.unarchive': '보관 취소',
  'common.favourite': '즐겨찾기',
  'common.favourites': '즐겨찾기',
  'common.pin': '고정',
  'common.unpin': '고정 해제',
  'common.expand': '펼치기',
  'common.collapse': '접기',
  'common.showMore': '더 보기',
  'common.showLess': '간략히 보기',
  'common.language': '언어',
  'common.darkMode': '다크 모드',
  'common.lightMode': '라이트 모드',
  'common.help': '도움말',
  'common.feedback': '피드백',
  'common.notifications': '알림',
  'common.rows': '행',
  'common.column': '열',
  'common.total': '합계',
  'common.page': '페이지',
  'common.of': '/',
  'common.notes': '메모',
};
